/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContentType } from './ContentType';
import {
    ContentTypeFromJSON,
    ContentTypeFromJSONTyped,
    ContentTypeToJSON,
    ContentTypeToJSONTyped,
} from './ContentType';
import type { ObjectiveProgress } from './ObjectiveProgress';
import {
    ObjectiveProgressFromJSON,
    ObjectiveProgressFromJSONTyped,
    ObjectiveProgressToJSON,
    ObjectiveProgressToJSONTyped,
} from './ObjectiveProgress';

/**
 * Per-user progression tracking. Polymorphic over targetType — Activation, Competition, MissionPlan, QuestConfig.
 * @export
 * @interface ActivityProgression
 */
export interface ActivityProgression {
    /**
     * 
     * @type {string}
     * @memberof ActivityProgression
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityProgression
     */
    userId: string;
    /**
     * Legacy — populated on rows backfilled from pre-polymorphic schema. New writers use targetType + targetId.
     * @type {string}
     * @memberof ActivityProgression
     */
    activationId?: string;
    /**
     * 
     * @type {ContentType}
     * @memberof ActivityProgression
     */
    targetType?: ContentType;
    /**
     * 
     * @type {string}
     * @memberof ActivityProgression
     */
    targetId?: string;
    /**
     * 
     * @type {{ [key: string]: ObjectiveProgress; }}
     * @memberof ActivityProgression
     */
    progression: { [key: string]: ObjectiveProgress; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ActivityProgression
     */
    prerequisites: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof ActivityProgression
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    claimedAt?: number;
    /**
     * Epoch ms when user dismissed the capped-state message. Null until seen.
     * @type {number}
     * @memberof ActivityProgression
     */
    cappedMessageSeenAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    lastStatReset: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    pointsReset: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    pointsTotal: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    completionCount: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    enrolledAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    segmentIndex?: number;
    /**
     * Route-computed on my-progression reads when the challenge has referralBonus configured — qualified referral count, capped at maxReferrals. Not stored.
     * @type {number}
     * @memberof ActivityProgression
     */
    referredCount?: number;
    /**
     * Route-computed alongside referredCount — referredCount × perReferralPoints. Not stored; the Grand Prize draw recomputes at draw time.
     * @type {number}
     * @memberof ActivityProgression
     */
    referralBonusPoints?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityProgression
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the ActivityProgression interface.
 */
export function instanceOfActivityProgression(value: object): value is ActivityProgression {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('lastStatReset' in value) || value['lastStatReset'] === undefined) return false;
    if (!('pointsReset' in value) || value['pointsReset'] === undefined) return false;
    if (!('pointsTotal' in value) || value['pointsTotal'] === undefined) return false;
    if (!('completionCount' in value) || value['completionCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ActivityProgressionFromJSON(json: any): ActivityProgression {
    return ActivityProgressionFromJSONTyped(json, false);
}

export function ActivityProgressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityProgression {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'activationId': json['activationId'] == null ? undefined : json['activationId'],
        'targetType': json['targetType'] == null ? undefined : ContentTypeFromJSON(json['targetType']),
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'progression': (mapValues(json['progression'], ObjectiveProgressFromJSON)),
        'prerequisites': json['prerequisites'],
        'isComplete': json['isComplete'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
        'cappedMessageSeenAt': json['cappedMessageSeenAt'] == null ? undefined : json['cappedMessageSeenAt'],
        'lastStatReset': json['lastStatReset'],
        'pointsReset': json['pointsReset'],
        'pointsTotal': json['pointsTotal'],
        'completionCount': json['completionCount'],
        'enrolledAt': json['enrolledAt'] == null ? undefined : json['enrolledAt'],
        'segmentIndex': json['segmentIndex'] == null ? undefined : json['segmentIndex'],
        'referredCount': json['referredCount'] == null ? undefined : json['referredCount'],
        'referralBonusPoints': json['referralBonusPoints'] == null ? undefined : json['referralBonusPoints'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function ActivityProgressionToJSON(json: any): ActivityProgression {
    return ActivityProgressionToJSONTyped(json, false);
}

export function ActivityProgressionToJSONTyped(value?: ActivityProgression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'activationId': value['activationId'],
        'targetType': ContentTypeToJSON(value['targetType']),
        'targetId': value['targetId'],
        'progression': (mapValues(value['progression'], ObjectiveProgressToJSON)),
        'prerequisites': value['prerequisites'],
        'isComplete': value['isComplete'],
        'claimedAt': value['claimedAt'],
        'cappedMessageSeenAt': value['cappedMessageSeenAt'],
        'lastStatReset': value['lastStatReset'],
        'pointsReset': value['pointsReset'],
        'pointsTotal': value['pointsTotal'],
        'completionCount': value['completionCount'],
        'enrolledAt': value['enrolledAt'],
        'segmentIndex': value['segmentIndex'],
        'referredCount': value['referredCount'],
        'referralBonusPoints': value['referralBonusPoints'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

